import React, { FC } from 'react'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { AccordionItem } from '@e3dc-react/shell/Elements/Accordion'
import { makeStyles } from 'tss-react/mui'
import { Box } from '@mui/system'
import BatteryStatusItem from './BatteryStatusItem'
import { useBatteryHealthStatus, useBatteryStatusItems } from 'src/Libs/batteries/hooks'

const useStyles = makeStyles()(theme => ({
  contentAccordion: {
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
  headerContent: {
    paddingLeft: theme.spacing(4),
  },
  container: {
    backgroundColor: theme.palette.grey.grey07,
    border: `1px solid ${theme.palette.grey.grey06}`,
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(2),
    lineHeight: 0,
  },
}))

interface Props {
  storageId: string | undefined
  batteryIndex: string | undefined
}

/**
 * Compopnent to display the health status of the battery according to the new battvo law
 */
const BatteryStatus: FC<Props> = ({ storageId, batteryIndex }) => {
  const { classes } = useStyles()
  const { t } = useCustomTranslation()
  const { batteryHealthStatus, moduleCount } = useBatteryHealthStatus(storageId, batteryIndex)
  const { statusItems, isLowVoltageBattery } = useBatteryStatusItems(batteryHealthStatus)

  if (!batteryHealthStatus) return null

  return (
    <AccordionItem
      title={t('system-settings.battery.status.section-title')}
      contentClassName={classes.contentAccordion}
      headerContentClassName={classes.headerContent}
    >
      <Box className={classes.container}>
        {statusItems.map(item => (
          <BatteryStatusItem
            key={item.title}
            title={item.title}
            text={item.textI18nKey}
            valueKeys={item.valueKeys}
            values={item.values}
            moduleCount={moduleCount}
            isLowVoltageBattery={isLowVoltageBattery}
          />
        ))}
      </Box>
    </AccordionItem>
  )
}

export default BatteryStatus
